import { actionTypes, SetSpidIdAndSigFromUrl } from "./Actions";

const setSpidIdAndSigFromUrl: SetSpidIdAndSigFromUrl = (spidId, sig) => ({
  sig,
  spidId,
  type: actionTypes.SET_SIG_AND_SPIDID_FROM_URL
});

export default setSpidIdAndSigFromUrl;
